export const LOAD_DOCUMENT_VERIFICATIONS_STARTED = "LOAD_DOCUMENT_VERIFICATIONS_STARTED";
export const LOAD_DOCUMENT_VERIFICATIONS_SUCCEEDED = "LOAD_DOCUMENT_VERIFICATIONS_SUCCEEDED";

export const MANUAL_VERIFICATIONS_LAUNCH_STARTED = "MANUAL_VERIFICATIONS_LAUNCH_STARTED";
export const MANUAL_VERIFICATIONS_LAUNCH_SUCCEEDED = "MANUAL_VERIFICATIONS_LAUNCH_SUCCEEDED";
export const MANUAL_VERIFICATIONS_LAUNCH_FAILED = "MANUAL_VERIFICATIONS_LAUNCH_FAILED";

export const LOAD_DOCUMENT_ENTITIES_SUCCEEDED = "LOAD_DOCUMENT_ENTITIES_SUCCEEDED";
export const LOAD_DOCUMENT_ENTITIES_STARTED = "LOAD_DOCUMENT_ENTITIES_STARTED";
export const LOAD_DOCUMENT_ENTITIES_FAILED = "LOAD_DOCUMENT_ENTITIES_FAILED";
